module.exports = __webpack_public_path__ + "files/3123a197388badcf39d3f75db5d87c37.png";